<template>
  <div class="move-to-fixed-details-popup">
    <popup :buttons="buttonOptions"
           :back-action="backAction"
           :close-action="closeAction">
      <template v-slot:title>
        <span>מה יקרה כשה{{ incomeOrExpense }} הזו תעבור לקבועות?</span>
      </template>
      <template v-slot:content>
        <div class="explanation">
          <div class="sub-title">
            המערכת תצפה שגם בחודשים הבאים {{ isIncomeCategory ? 'תכנס' : 'תצא' }} {{ incomeOrExpense }} דומה, כלומר, היא תקרה:</div>
          <div>
            <div>בערך באותו זמן בחודש</div>
            <div>בערך באותו סכום</div>
            <div>ובאותו בית עסק</div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <info-tool-tip class="info-tooltip"
                 :text="tooltipText"
                 :popup-text="'לשייך אותה למקום הנכון >'"
                 icon-path="/images/info-icon-blue-full.svg"
                 :underLineLink=true
                 :background-color="'#F1F7FF'"
                 :open-popup-handler="MoveToExistingSequence" />
      </template>
    </popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseUI from '@riseupil/base-ui';
import InfoToolTip from '@/base-components/onboarding/InfoToolTip';
import transactionUtils from '@/utils/transaction';
import Segment from '@/Segment';
import ChangeTransactionCategoryPopup from '../ChangeTransactionCategoryPopup.vue';
import MoveToFixedSummaryPopup from '../MoveToFixedSummaryPopup.vue';
import MoveToFixedBiMonthlyCheckPopupVue from '../MoveToFixedBiMonthlyCheckPopup.vue';

export default {
  name: 'MoveToFixedDetailsPopup',
  components: {
    Popup: BaseUI.Popup,
    InfoToolTip,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    MoveToAddToExistingSequence: {
      type: Function,
      required: true,
    },
    useCloseAction: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    Segment.trackUserInteraction('WhichFixedExpanseIsItPopup_Shown', {
      businessName: this.predictedTransaction.businessName,
      originalCategory: this.predictedTransaction.expense,
      originalPlacement: this.predictedTransaction.placement,
      transactionId: this.predictedTransaction.transactionId,
    });
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', ['incomeOrExpense', 'isIncomeCategory']),
    buttonOptions() {
      return [{
        title: 'הבנתי, זו הכוונה שלי',
        size: 'slim',
        action: () => this.onSave(),
        variant: 'primary',
      }];
    },
    incomeOrExpense() {
      return transactionUtils.incomeOrExpense(this.predictedTransaction);
    },
    backAction() {
      return this.useCloseAction ? null : this.back;
    },
    closeAction() {
      return this.useCloseAction ? this.closeModal : null;
    },
    tooltipText() {
      return `ה${this.incomeOrExpense} הזו כבר הופיעה בקבועות שלך בתזרים הקודם?\n אפשר`;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    back() {
      this.$emit('close');
      this.openModal({
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    MoveToExistingSequence() {
      Segment.trackUserInteraction('WhichFixedExpanseIsItPopup_ExistingFixedClicked', {
        businessName: this.predictedTransaction.businessName,
        originalCategory: this.predictedTransaction.expense,
        originalPlacement: this.predictedTransaction.placement,
        transactionId: this.predictedTransaction.transactionId,
      });
      this.MoveToAddToExistingSequence();
    },
    onSave() {
      Segment.trackUserInteraction('WhichFixedExpanseIsItPopup_NewFixedClicked', {
        businessName: this.predictedTransaction.businessName,
        originalCategory: this.predictedTransaction.expense,
        originalPlacement: this.predictedTransaction.placement,
        transactionId: this.predictedTransaction.transactionId,
      });
      const nextComponent = this.isIncomeCategory ? MoveToFixedSummaryPopup : MoveToFixedBiMonthlyCheckPopupVue;
      this.openModal({
        component: nextComponent,
        props: {},
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/typography';
@import '@/scss/mixins';

.move-to-fixed-details-popup {

.explanation {
  line-height: 24px;
  white-space: pre-line;

  .sub-title {
    margin-bottom: 26px;
  }
}

.info-tooltip {
    text-align: start;
  }
}
</style>
